import { Dialog, DialogContent, CircularProgress } from "@mui/material";

const CustomLoader = () => (
  <Dialog
    open
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent>
      <CircularProgress sx={{ color: "#6B35EE" }} />
    </DialogContent>
  </Dialog>
);
export default CustomLoader;
